import { useTranslation, Trans } from "react-i18next"
import { Link } from "wouter"
import { Mail, Check } from "lucide-react"

// Pitch panel shown next to the login / register form for camp owners
// who land on the admin URL without an account. Pure UI, no backend —
// the CTA is a mailto link to Fohet sales. See docs/todo.md "new1".
export const AdminMarketingPanel = () => {
    const { t } = useTranslation()

    const featureKeys = [
        "feature1",
        "feature2",
        "feature3",
        "feature4",
        "feature5",
        "feature6",
        "feature7",
        "feature8",
    ] as const

    const subject = encodeURIComponent(t("admin.marketing.mailSubject"))
    const mailto = `mailto:info@fohet.cz?subject=${subject}`

    return (
        <div className="bg-white rounded-[40px] border border-slate-100 shadow-xl p-10 w-full max-w-md">
            <div className="mb-6 text-center">
                <h2 className="text-3xl font-black tracking-tight text-slate-900 mb-2">
                    {t("admin.marketing.title")}
                </h2>
                <p className="text-slate-500 font-bold">{t("admin.marketing.tagline")}</p>
            </div>

            <ul className="space-y-2 mb-8">
                {featureKeys.map((key) => (
                    <li key={key} className="flex items-start gap-3">
                        <Check className="size-5 shrink-0 text-brand mt-0.5" />
                        <span className="text-slate-700 font-bold text-sm">{t(`admin.marketing.${key}`)}</span>
                    </li>
                ))}
            </ul>

            <a
                href={mailto}
                className="flex items-center justify-center gap-2 px-5 py-3 rounded-[28px] bg-brand text-white font-black hover:bg-brand-dark transition-colors active:scale-95 w-full"
            >
                <Mail className="size-4" />
                {t("admin.marketing.cta")}
            </a>

            {/* Fallback for users without a registered mail client — copy this address. */}
            <p className="mt-3 text-center text-xs font-bold text-slate-500">
                {t("admin.marketing.mailFallback")}{" "}
                <a href="mailto:info@fohet.cz" className="text-brand hover:text-brand-dark font-black">
                    info@fohet.cz
                </a>
            </p>

            {/* Legal links — placeholder pages until the lawyer drafts the actual texts (todo new2A). */}
            <p className="mt-2 text-center text-xs font-bold text-slate-400">
                <Trans
                    i18nKey="admin.marketing.legal"
                    components={{
                        terms: <Link to="/legal/terms" className="text-slate-500 hover:text-brand transition-colors underline" />,
                        privacy: <Link to="/legal/privacy" className="text-slate-500 hover:text-brand transition-colors underline" />,
                    }}
                />
            </p>
        </div>
    )
}
